export const fyaiDefaultConfig = {
  officialUrl: "https://www.fengyueaiapp.net",
  domain: "fengyueaiapp.net",
  contactEmail: "txby666666@163.com",
  downloadLinks: {
    android: "https://www.fengyueaiapp.net",
    ios: "https://www.fengyueaiapp.net",
    harmonyos: "https://www.fengyueaiapp.net",
    windows: "https://www.fengyueaiapp.net",
  },
};